import { RouteType } from "./interfaces"
import conviteRoutes from "@modules/convite/routes"

const routes: RouteType[] = [
    ...conviteRoutes
]

const routesKeys: string[] = routes.reduce((acc: string[], route) => {
    acc.push(route.key)
    if (route.subRoutes) route.subRoutes.forEach(subRoute => acc.push(subRoute.key))
    return acc
}, [])

const notShowRoutesKeys: string[] = []

export { routes, routesKeys, notShowRoutesKeys }